export const MARKETPLACE_PRODUCT_REQUEST = 'MARKETPLACE_PRODUCT_REQUEST';
export const MARKETPLACE_PRODUCT_SUCCESS = 'MARKETPLACE_PRODUCT_SUCCESS';
export const MARKETPLACE_PRODUCT_FAILURE = 'MARKETPLACE_PRODUCT_FAILURE';

export const MARKETPLACE_PRODUCT_LIST_REQUEST = 'MARKETPLACE_PRODUCT_LIST_REQUEST';
export const MARKETPLACE_PRODUCT_LIST_SUCCESS = 'MARKETPLACE_PRODUCT_LIST_SUCCESS';
export const MARKETPLACE_PRODUCT_LIST_FAILURE = 'MARKETPLACE_PRODUCT_LIST_FAILURE';

export const MARKETPLACE_MTRACK_CONSENT_DATA_REQUEST = 'MARKETPLACE_MTRACK_CONSENT_DATA_REQUEST';
export const MARKETPLACE_MTRACK_CONSENT_DATA_SUCCESS = 'MARKETPLACE_MTRACK_CONSENT_DATA_SUCCESS';
export const MARKETPLACE_MTRACK_CONSENT_DATA_FAILURE = 'MARKETPLACE_MTRACK_CONSENT_DATA_FAILURE';

export const MARKETPLACE_RESET = 'MARKETPLACE_RESET';
